let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5khw4")).then(() => parcelRequire('6cEsd'));